'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./Pagination.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Pagination = function (_a) {
    var totalPages = _a.totalPages, currentPage = _a.currentPage, handlePagination = _a.handlePagination;
    var paginationConfig = {
        totalPages: totalPages,
        hasPrevPage: currentPage > 1,
        hasNextPage: currentPage !== totalPages,
        prevPage: currentPage - 1,
        nextPage: currentPage + 1,
        page: currentPage,
    };
    var getPageList = function (currentPage, lastPage) {
        var leftRange = currentPage - 2;
        var rightRange = currentPage + 3;
        var pageList = [1];
        for (var index = leftRange; index < rightRange; index++) {
            if (index > 1 && index < lastPage) {
                pageList.push(index);
            }
        }
        if (lastPage > 1) {
            pageList.push(lastPage);
        }
        return pageList;
    };
    var generatePagination = function (currentPage, totalPages) {
        var pageList = getPageList(currentPage, totalPages);
        var pagination = [];
        var count;
        for (var _i = 0, pageList_1 = pageList; _i < pageList_1.length; _i++) {
            var page = pageList_1[_i];
            if (count) {
                if ((page - count) !== 1) {
                    pagination.push('&hellip;');
                }
            }
            pagination.push(page);
            count = page;
        }
        return pagination;
    };
    var pagination = generatePagination(currentPage, totalPages);
    return (React__default['default'].createElement("div", { className: "lp__pagination" },
        React__default['default'].createElement("ul", { className: "lp__pagination--group" },
            paginationConfig.hasPrevPage && (React__default['default'].createElement("li", { className: "bordered" },
                React__default['default'].createElement("a", { href: "#", onClick: function (e) {
                        e.persist();
                        handlePagination(e, paginationConfig.prevPage);
                    } },
                    React__default['default'].createElement("span", null, "\u1438")))),
            (pagination && pagination.length) && (pagination.map(function (page, i) { return (React__default['default'].createElement("li", { key: i, className: index['default'](paginationConfig.page === page && 'bordered selected') },
                React__default['default'].createElement("a", { href: "#", onClick: function (e) {
                        e.persist();
                        handlePagination(e, page);
                    } }, page === '&hellip;'
                    ? React__default['default'].createElement("span", null, "\u2026")
                    : page))); })),
            paginationConfig.hasNextPage && (React__default['default'].createElement("li", { className: "bordered" },
                React__default['default'].createElement("a", { href: "#", onClick: function (e) { return handlePagination(e, paginationConfig.nextPage); } },
                    React__default['default'].createElement("span", null, "\u1433")))))));
};

exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map
